import React from "react";
import { TopPanel } from "../components/TopPanel";
import { SidePanel } from "../components/sidePanel/SidePanel";
import { CategoriesComponent } from "../components/sidePanel/categories/CategoriesComponent";
import { Outlet, useNavigate } from "react-router-dom";
import { FilterComponent } from "../components/sidePanel/FilterComponent";
import { Category } from "../components/sidePanel/categories/Category";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  changeCurrentFilteredRequest,
  selectCurrentFilterdConsultRequest,
} from "./listasSlice";
import { DropDown } from "../../common/components/Btns/DropDown";

export const ManualLists = () => {
  const currentFilteredRequest = useAppSelector(
    selectCurrentFilterdConsultRequest
  );

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const getFilterItemsByActiveComponent = () => {
    const statusOptions: { value: string; label: string }[] = [
      { label: "En proceso", value: "started" },
      { label: "Terminado", value: "finished" },
    ];
    const statusDropdown = (
      <DropDown
        key={"Status"}
        title="Estado de la consulta"
        options={statusOptions}
        isClearable
        maxContent
        onChange={(e) => {
          if (e) {
            if (!e || !e.value) {
              dispatch(
                changeCurrentFilteredRequest({
                  ...currentFilteredRequest,
                  status: null,
                })
              );
            } else {
              dispatch(
                changeCurrentFilteredRequest({
                  ...currentFilteredRequest,
                  status: e.value as "started" | "finished",
                })
              );
            }
          }
        }}
      />
    );
    return (
      <FilterComponent
        key={0}
        hasCalendar={true}
        endDate={
          currentFilteredRequest.endDate
            ? new Date(currentFilteredRequest.endDate)
            : null
        }
        startDate={
          currentFilteredRequest.startDate
            ? new Date(currentFilteredRequest.startDate)
            : null
        }
        setEndDate={(date: Date) => {
          if (date) {
            dispatch(
              changeCurrentFilteredRequest({
                ...currentFilteredRequest,
                endDate: date.toISOString(),
              })
            );
          }
        }}
        setStartDate={(date: Date) => {
          if (date) {
            dispatch(
              changeCurrentFilteredRequest({
                ...currentFilteredRequest,
                startDate: date.toISOString(),
              })
            );
          }
        }}
        resetFunction={() => {
          dispatch(
            changeCurrentFilteredRequest({
              ...currentFilteredRequest,
              startDate: null,
              endDate: null,
            })
          );
        }}
        items={[statusDropdown]}
      />
    );
  };

  const getCategoryItems = () => {
    const categories: JSX.Element[] = [];
    categories.push(
      <Category
        key={0}
        name="Consultas realizadas"
        onClick={(e) => {
          e.preventDefault();
          navigate("/services/manualLists/");
        }}
        selected={true}
      />
    );
    return categories;
  };
  return (
    <div
      className="flex-col"
      style={{
        paddingLeft: "0.5%",
        paddingTop: "0.5%",
        height: "100%",
        width: "100%",
        overflow: "auto",
      }}
    >
      <TopPanel />
      <div
        className="flex-row"
        style={{ justifyContent: "start", height: "95%" }}
      >
        <SidePanel
          filter={getFilterItemsByActiveComponent()}
          categories={<CategoriesComponent categories={getCategoryItems()} />}
        />

        <div
          className="flex-col"
          style={{ width: "80%", justifyContent: "end" }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
};
